/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/Meeting';
export default {
  date: 'Fecha',
  time: 'Hora',
  hours: '{howMany} h',
  minutes: '{howMany} min',
  today: 'Hoy',
  duration: 'Duración',
  topic: 'Título de la reunión',
  voIPOnly: 'Solo audio de internet',
  telephonyOnly: 'Solo teléfono',
  both: 'Audio de internet y teléfono',
  thirdParty: 'Audio de terceros',
  meetingId: 'Id. de la reunión',
  password: 'Contraseña',
  video: 'Video',
  audio: 'Audio',
  scheduleFor: 'Programar en nombre de',
  [ASSISTED_USERS_MYSELF]: 'Mí mismo',
  meetingOptions: 'Opciones de reunión',
  meetingSettings: 'Configuración de la reunión',
  rcMeetingSettings: 'Configuración de Video Meeting',
  audioOptions: 'Opciones de audio',
  recurringMeeting: 'Reunión recurrente',
  recurringNote: 'Nota: Active esta opción cuando elija "Recurrencia"',
  joinBeforeHost: 'Permitir que los participantes se unan antes del anfitrión',
  turnOffCamera: 'Apagar la cámara de los participantes',
  turnOffHostCamera: 'Apagar la cámara del host cuando se une a la reunión',
  requirePassword: 'Solicitar contraseña',
  enterPassword: 'Ingrese la contraseña',
  setPassword: 'Configurar contraseña *',
  passwordEmptyError: 'Se requiere la contraseña de la reunión',
  rcmPasswordInvalidError:
    'Su contraseña debe contener de 1 a 10 caracteres o números y no puede tener símbolos, salvo @, * o -',
  rcmPasswordHintText:
    'Su contraseña debe contener de 1 a 10 caracteres o números y no puede tener símbolos, excepto @, * o -',
  usePersonalMeetingId: 'Usar el ID de reunión personal',
  pmiChangeConfirm: 'Si quiere hacer cambios en su reunión personal, ',
  changePmiSettings: 'cambie la configuración del PMI',
  pmiSettingChangeAlert:
    'Si cambia la configuración y programa esta reunión, todas las reuniones con el mismo Id. de reunión personal compartirán los últimos ajustes.',
  lockedTooltip:
    'Esta configuración la gestiona el administrador de su empresa ',
  when: 'Cuándo',
  recurringDescribe:
    'Recuerde comprobar la periodicidad o repetición en la invitación de calendario enviada a los asistentes.',
} as const;

// @key: @#@"date"@#@ @source: @#@"Date"@#@
// @key: @#@"time"@#@ @source: @#@"Time"@#@
// @key: @#@"hours"@#@ @source: @#@"{howMany} hr"@#@
// @key: @#@"minutes"@#@ @source: @#@"{howMany} min"@#@
// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"duration"@#@ @source: @#@"Duration"@#@
// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
// @key: @#@"voIPOnly"@#@ @source: @#@"Internet audio only"@#@
// @key: @#@"telephonyOnly"@#@ @source: @#@"Telephone only"@#@
// @key: @#@"both"@#@ @source: @#@"Telephone and Internet audio"@#@
// @key: @#@"thirdParty"@#@ @source: @#@"3rd party audio"@#@
// @key: @#@"meetingId"@#@ @source: @#@"Meeting ID"@#@
// @key: @#@"password"@#@ @source: @#@"Password"@#@
// @key: @#@"video"@#@ @source: @#@"Video"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"meetingOptions"@#@ @source: @#@"Meeting options"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"rcMeetingSettings"@#@ @source: @#@"Video Meeting settings"@#@
// @key: @#@"audioOptions"@#@ @source: @#@"Audio options"@#@
// @key: @#@"recurringMeeting"@#@ @source: @#@"Recurring meeting"@#@
// @key: @#@"recurringNote"@#@ @source: @#@"Note: Enable this one when choosing \"Recurrence\""@#@
// @key: @#@"joinBeforeHost"@#@ @source: @#@"Allow participants to join before host"@#@
// @key: @#@"turnOffCamera"@#@ @source: @#@"Turn off camera for participants"@#@
// @key: @#@"turnOffHostCamera"@#@ @source: @#@"Turn off camera for host when joining meeting"@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"setPassword"@#@ @source: @#@"Set password *"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"rcmPasswordInvalidError"@#@ @source: @#@"Your password must be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"rcmPasswordHintText"@#@ @source: @#@"Your password should be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"usePersonalMeetingId"@#@ @source: @#@"Use Personal Meeting ID"@#@
// @key: @#@"pmiChangeConfirm"@#@ @source: @#@"If you want to make changes for your Personal Meeting, "@#@
// @key: @#@"changePmiSettings"@#@ @source: @#@"change PMI settings"@#@
// @key: @#@"pmiSettingChangeAlert"@#@ @source: @#@"If you change the settings and schedule this meeting, all of meetings with Personal Meeting ID will use the same latest settings."@#@
// @key: @#@"lockedTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"when"@#@ @source: @#@"When"@#@
// @key: @#@"recurringDescribe"@#@ @source: @#@"Please remember to check recurrence or repeat in your calendar invitation to your attendees."@#@
